import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate, useLocation } from "react-router-dom";
import banner from '../assets/images/banner-v2.jpg';

const Home = () => {
  const { keycloak } = useKeycloak();

  const [alertMessage, SetAlertMessage] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  const startLogin = () => {
    keycloak.login();
  }

  useEffect(() => {
    if (location.state)
    {
      if (location.state.return === 1)
      {
        SetAlertMessage('Registo concluído com sucesso. Inicie a sessão.');
      } else if (location.state.return === 2)
      {
        SetAlertMessage('Palavra-chave alterada com sucesso. Inicie a sessão.');
      }
    }
  }, []);

 return (
  <div>
    <Helmet>
      <style>
          {`
              body {
                  background-color: #FFFFFF;
              }
          `}
      </style>
    </Helmet>
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="row">
            <img src={banner} height="100%" />
          </div>
        </div>
        <div className="col-md-6">
        {alertMessage.length !== 0 && (
        <div className="alert alert-success alert-layer border-0 d-flex align-items-center mb-5" role="alert">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-2">
            <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
              <path d="M7.48581818,10.5709091 C7.344,10.7127273 7.15781818,10.784 6.97163636,10.784 C6.78545455,10.784 6.59927273,10.7127273 6.45745455,10.5709091 L4.40072727,8.51418182 L5.42909091,7.48581818 L6.97163636,9.02836364 L10.5709091,5.42909091 L11.5992727,6.45745455 L7.48581818,10.5709091 Z M8,0 C3.58909091,0 0,3.58836364 0,8 C0,12.4109091 3.58909091,16 8,16 C12.4109091,16 16,12.4109091 16,8 C16,3.58836364 12.4109091,0 8,0 L8,0 Z" />
            </g>
          </svg>
          <div>
            {alertMessage}
          </div>
        </div>
        )}
          <h1 className="mt-5">Área de Cliente</h1>
          <h2 className="mb-5">Damos-lhe as boas-vindas.</h2>
          <p className="mb-5" style={{fontSize:'15px'}}>Nesta área poderá encontrar a informação sempre actualizada e gratuita respeitante ao seu fundo de pensões ou à sua adesão colectiva a Fundos de Pensões Abertos geridos pela CGD Pensões.</p>
          <button
            type="button" className="btn btn-primary me-4"
            onClick={() =>  startLogin()}
          >
            Iniciar sessão
          </button>
          <button
            type="button" className="btn btn-secondary"
            onClick={() => navigate('/registo')}
          >
            Novo registo
          </button>
          <p className="mt-4 mb-5">
            Recuperar palavra-passe? <a href="/recuperarpassword">Faça-o aqui.</a>
          </p>
        </div>
      </div>
    </div>
  </div>
 );
};

export default Home;
